import { render, staticRenderFns } from "./board-page.vue?vue&type=template&id=510f5a58&"
import script from "./board-page.vue?vue&type=script&lang=js&"
export * from "./board-page.vue?vue&type=script&lang=js&"
import style0 from "./board-page.vue?vue&type=style&index=0&id=510f5a58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports